import React, { useEffect, useState } from 'react';
import './styles/buildcoins.css';
import BuildCoinsTransactionHistory from './BuildCoinsTransactionHistory/BuildCoinsTransactionHistory';
import buildCoinsService from '../service/BuildCoins.service';
import { EarningOpportunity } from '../dto/BuildCoins.dto';
import { ProfileService } from '../service/Profile.service';
import { ApiService } from '../../../shared/service/Apiservice';
import axios from 'axios';


const BuildCoins: React.FC = () => {
  const [showActivity, setShowActivity] = useState(false);
  const [loading, setLoading] = useState(true);
  const [, setOpportunities] = useState<EarningOpportunity[]>([]);
  const [userBalance, setUserBalance] = useState<number>(0);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        
        // Create profile service instance
        const apiService = new ApiService(axios.create());
        const profileService = new ProfileService(apiService);
        
        const [profileRes, oppRes] = await Promise.all([
          profileService.getUserProfile(),
          buildCoinsService.getEarningOpportunities(),
        ]);

        // Use referralCredits from user profile
        if (profileRes.success && profileRes.user) {
          setUserBalance(profileRes.user.referralCredits || 0);
        }
        if (oppRes.success) setOpportunities(oppRes.data);
      } catch (e) {
        // Silently fail for now; can add toast later
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleViewActivity = () => {
    setShowActivity(true);
  };

  if (showActivity) {
    return <BuildCoinsTransactionHistory />;
  }

  return (
    <div className="buildcoins-container">
      {/* Main Card Border */}
      <div className="main-card-border">
        <div className="header-section">
          <h2 className="build-coin-text">Build Coin Balance</h2>
          <div className="coin-amount">
            <span className="rupee-icon">₹</span>
            <span className="amount">{loading ? '—' : (Math.round(userBalance * 100) / 100)}</span>
          </div>
        </div>

        <div className="image-section">
          <div className="image-card-border">
            <img 
              src="/images/buildcoins.png" 
              alt="Build Coins" 
              className="buildcoins-image"
            />
            <div className="build-card">
              <h3 className="build-card-text">What are Build Coins ?</h3>
            </div>
            <p className="shop-earn-text">Shop Now and Earn</p>
          </div>
        </div>

        <button className="view-activity-btn" onClick={handleViewActivity}>
          <span>View Coin Activity</span>
          <svg 
            className="arrow-icon" 
            width="16" 
            height="16" 
            viewBox="0 0 16 16" 
            fill="none"
          >
            <path 
              d="M6 12L10 8L6 4" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {/* <div className="three-cards-row">
          <div className="reward-card-box">
            <img 
              src="/icon/current.png" 
              alt="Earn on orders" 
              className="reward-image"
            />
          </div>
          <div className="reward-card-box">
            <img 
              src="/icon/current.png" 
              alt="Invite friends" 
              className="reward-image"
            />
          </div>
          <div className="reward-card-box">
            <img 
              src="/icon/current.png" 
              alt="Review purchases" 
              className="reward-image"
            />
          </div>
        </div>

        <div className="exciting-rewards-section">
          <h3 className="rewards-title">Exciting Rewards for You</h3>
          
          <div className="rewards-slider">
            <div className="slider-track">
              {(opportunities.length ? opportunities : rewardCards).map((op, index) => (
                <div key={index} className="slider-card">
                  <img 
                    src={opportunities.length ? '/images/reward.png' : '/images/reward.png'} 
                    alt={opportunities.length ? String((op as EarningOpportunity).title) : `Reward ${index + 1}`} 
                    className="slider-reward-image"
                  />
                </div>
              ))}
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default BuildCoins;